// frontend/src/components/piracy/PiracyIndicatorCard.tsx
// Карточка-индикатор пиратской активности для admin dashboard

import React from 'react';
import { Paper, Typography, Box, Chip } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import type { PiracySummary } from '../../api/piracyApi';

interface PiracyIndicatorCardProps {
  summary: PiracySummary | null;
  loading?: boolean;
  onClick?: () => void;
}

const PiracyIndicatorCard: React.FC<PiracyIndicatorCardProps> = ({ summary, loading, onClick }) => {
  if (loading || !summary) {
    return (
      <Paper
        sx={{ p: 2, cursor: onClick ? 'pointer' : 'default', minWidth: 200 }}
        onClick={onClick}
      >
        <Typography variant="subtitle2" color="text.secondary">
          HRA Piracy
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {loading ? 'Загрузка...' : 'Нет данных'}
        </Typography>
      </Paper>
    );
  }

  const hasOpenTransits = summary.openTransits > 0;

  return (
    <Paper
      sx={{
        p: 2,
        cursor: onClick ? 'pointer' : 'default',
        minWidth: 200,
        borderLeft: hasOpenTransits ? '4px solid #ff9800' : '4px solid #4caf50',
        '&:hover': onClick ? { boxShadow: 3 } : undefined,
      }}
      onClick={onClick}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <WarningAmberIcon color={hasOpenTransits ? 'warning' : 'success'} fontSize="small" />
        <Typography variant="subtitle2">Транзит HRA</Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        <Chip
          size="small"
          label={`Сообщений за смену: ${summary.reports.shift}`}
          color={summary.reports.shift > 0 ? 'warning' : 'default'}
          variant="outlined"
        />
        <Chip
          size="small"
          label={`Открытых транзитов: ${summary.openTransits}`}
          color={hasOpenTransits ? 'error' : 'default'}
          variant="outlined"
        />
        <Chip size="small" label={`Судов: ${summary.activeVessels}`} variant="outlined" />
      </Box>

      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
        Всего: {summary.reports.total} | Неделя: {summary.reports.week} | Месяц:{' '}
        {summary.reports.month}
      </Typography>
    </Paper>
  );
};

export default PiracyIndicatorCard;
